import React, { HTMLAttributes, ReactNode } from "react";

import classnames from "classnames";

import { useWombatTheme } from "../../theme";

type FormLabelProps = {
  /**
   * Label for the field(s)
   */
  label: ReactNode;
  /**
   * Description of the form entry
   */
  disabled?: boolean;
} & Omit<HTMLAttributes<HTMLLabelElement>, "label">;

/**
 * FormLabel component is meant to receive any input children that does not expose a label field
 * eg: Custom group of inputs
 */
const FormLabel: React.FC<FormLabelProps> = ({
  label,
  disabled,
  children,
  ...props
}) => {
  const { theme } = useWombatTheme();

  const labelStyle = classnames(
    theme.form.input.label.base,
    disabled ? theme.form.input.label.disabled : theme.form.input.label.able
  );

  return (
    <label {...props}>
      <span className={labelStyle}>{label}</span>
      {children}
    </label>
  );
};

export default React.memo(FormLabel);
